module.exports = __webpack_public_path__ + "img/card-providers.c6d39e5b.svg";